module.exports = __webpack_public_path__ + "img/desc1.e557b1de.png";